import $ from 'jquery';
import Swiper, { Pagination  , Navigation} from 'swiper';

function initPartnersDirectory() {

    $('.partners-directory').each(function () {
        let container = $(this).closest('.partners-directory');
        let slider = $(this).find('.swiper-container');
        let pagination = $(this).find('.swiper-pagination');

        let swiper = new Swiper(slider.get(0), {
            modules: [Pagination , Navigation], // Include EffectFade here
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: false,
            speed: 500,
            centeredSlides: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: pagination.get(0),
                clickable: true
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30
                }
              }
        });
        function updateSwiper() {
            console.log('Updating Swiper', swiper);
            if (swiper) {
                swiper.update();
            } else {
                console.log('Swiper instance not found');
            }
        }
        function updatePosts(){
            var locationTermId = container.find('[data-taxonomy="partners-location"] .filter-cat-dropdown__dropdown__btn.active').data('id');
            var featureTermId = container.find('[data-taxonomy="key-feature"] .filter-cat-dropdown__dropdown__btn.active').data('id');

            console.log(locationTermId , featureTermId);
            $.ajax({
                url: ajaxObject.ajax_url,
                type: 'POST',
                data: {
                    action: 'filter_partners',
                    nonce: ajaxObject.ajax_nonce,
                    location_id: locationTermId,
                    feature_id: featureTermId
                },
                success: function (response) {
                    $('.partners-directory__list').html(response);
                    updateSwiper();
                }
            });
        }
        $(this).find('.filter-cat-dropdown').each(function(){
            let header = $(this).find('.filter-cat-dropdown__header-select-current');
            let button = $(this).find('.filter-cat-dropdown__dropdown__btn');
            let selectBtn = $(this).find('.filter-cat-dropdown__header-select');
            let selectDropdown = $(this).find('.filter-cat-dropdown__dropdown');
            button.on('click' , function(e){
                e.preventDefault();
                button.removeClass('active');
                $(this).addClass('active');
                let text = $(this).text();
                header.text(text);
                updatePosts();
            });
            selectBtn.on('click' , function(){
                selectDropdown.slideToggle();
                selectBtn.toggleClass('active');
            });
        });
        
    });

}

export { initPartnersDirectory };
